module.exports = __webpack_public_path__ + "img/insta.1685dbc9.svg";